import { IMachineTracking } from './signal-r/machine-tracking';

export enum ChatFilterType {
  SEARCH = 'Search',
  ZONE = 'Zone',
  MACHINE_TYPE = 'MachineType',
  STATUS_MACHINE = 'StatusMachine',
}

export interface IMessengerStateModel {
  messages: IMachineMessage[];
  unreadMessages: IMachineMessage[];
  activeMessage: IMachineMessage;
  isChatLoading: boolean;
  messengerFilter: IFilterState;
  messageUpdated: IChatMessage;
  newTracking: IMachineTracking;
  isSendingMessage: boolean;
  isCheckingMessages: boolean;
  messagesChecked: boolean;
  isGlobalMessageOpen: boolean;
  sidebarNotification: number;
}
export interface IMachineMessageResponse {
  machineId: number;
  machineName: string;
  machineTypeName: string;
  machineTypeId: number;
  machineIcon?: string;
  zoneId: number;
  zoneName: string;
  statusName: string;
  statusColor: string;
  statusFamilyName: string;
  statusFamilyColor: string;
  operatorName: string;
  hourStart: number;
  fuelStart: number;
  body: string;
  createdAt: string;
  readAt: string;
  unreadMessageQty: number;
  isConnected: boolean;
  zoneParkId: number;
  zoneParkName: string;
  parentStatusImagePrefix: string;
  senderName: string;
  parentStatusSecondColor?: string;
  parentStatusThirdColor?: string;
}

export interface IMachineMessage {
  machineId: number;
  machineName: string;
  machineTypeName: string;
  statusName: string;
  statusColor: string;
  statusFamilyColor?: string;
  statusFamilyName: string;
  operatorName: string;
  body: string;
  createdAt: string;
  unreadMessageQty: number;
  timeLapsed: string;
  imageKey: string;
  zoneName: string;
  isConnected: boolean;
  readAt: string;
  hourStart: number;
  fuelStart: number;
  chatMessages?: IChatMessageResponse;
  zoneParkId: number;
  zoneParkName: string;
  machineTypeId: number;
  parentStatusImagePrefix: string;
  machineIcon?: string;
  parentStatusSecondColor?: string;
  parentStatusThirdColor?: string;
  preventScroll?: boolean;
}

export interface IChatMessageResponse {
  totalCount: number;
  data: IChatMessage[];
}

export interface IChatMessage {
  createdAt: string;
  machineId: number;
  messageId: number;
  messageType: string;
  readAt: string;
  remoteId: number;
  senderName: string;
  senderRole: string;
  syncAt: string;
  text: string;
  rownumber?: number;
  statusName?: string;
  statusFamilyName?: string;
  machineName?: string;
  isSender?: boolean;
  hasDateDelimiter?: boolean;
  isYesterday?: boolean;
  statusColor?: string;
  source?: any;
  tempLocalId?: number;
  filterMachineId?: number;
}

// export interface INewMachineMessageReceived {
//   createdAt: string;
//   machineId: number;
//   messageId: number;
//   messageType: string;
//   readAt: string;
//   remoteId: number;
//   senderName: string;
//   rownumber: number;
//   senderRole: string;
//   source: any;
//   syncAt: string;
//   tempLocalId: number;
//   text: string;
// }

export interface IChatFilter {
  search: string;
  zoneParkIds: number[];
  statusNames: string[];
  machineTypeId: number;
}

export interface IFilterAction {
  type: ChatFilterType;
  value: any;
}

export interface IFilterState {
  isActive: boolean;
  search: string;
}

export interface IChatSender {
  senderName: string;
  machineId: number;
  senderRole: string;
  text: string;
}

export interface IGlobalMessage {
  senderName?: string;
  machineId?: number;
  senderRole: string;
  text: string;
  filterMachineId?: string;
}
